import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import Radio from '@material-ui/core/Radio';
import { green, red, blue, purple, indigo, grey } from '@material-ui/core/colors';

import { SessionContext } from "../context/session-context";

import SelectUp from '../assets/icons/SelectObject_upSkin.png';
import SelectDown from '../assets/icons/SelectObject_downSkin.png';
import DeleteUp from '../assets/icons/Delete_upSkin.png';
import DeleteDown from '../assets/icons/Delete_downSkin.png';

import DrawSquareUp from '../assets/icons/DrawSquare_upSkin.png';
import DrawSquareDown from '../assets/icons/DrawSquare_downSkin.png';
import DrawNodesUp from '../assets/icons/DrawNodes_upSkin.png';
import DrawNodesDown from '../assets/icons/DrawNodes_downSkin.png';
import EditObjectUp from '../assets/icons/EditObject_upSkin.png';
import EditObjectDown from '../assets/icons/EditObject_downSkin.png';
import LabelUp from '../assets/icons/LargeLabel_upSkin.png';
import LabelDown from '../assets/icons/LargeLabel_downSkin.png'
import FillShapeUp from '../assets/icons/FillShape_upSkin.png';
import FillShapeDown from '../assets/icons/FillShape_downSkin.png'

import MeasureAreaUp from '../assets/icons/MeasureArea_upSkin.png';
import MeasureAreaDown from '../assets/icons/MeasureArea_downSkin.png'
import MeasureLengthUp from '../assets/icons/MeasureLength_upSkin.png';
import MeasureLengthDown from '../assets/icons/MeasureLength_downSkin.png'

import ToolStylePaper from './ToolsStylePaper';
import { TrainOutlined } from '@material-ui/icons';


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);


export default function AnnotationToolsPaper(props) {

  const [sState, sDispatch] = useContext(SessionContext);
  const [textToolDisplay, setTextToolDisplay] = useState('none');
  const [colourPickerDisplay, setColourPickerDisplay] = useState('block');
  const [measurementDisplay, setMeasurementDisplay] = useState('block');

  const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        top: 140,
        right: 30,
        display:props.display,
        padding: '2px 2px',
        width: 180,
        height: 600,
        zIndex:120,
        border: '2px solid #0C4C35',
        borderRadius: '20',
        backgroundColor: '#FFF', //#0C4C35 
        '& .MuiRadio-root':{
          padding: 4,
        },
      },
      paperDiv:{
        overflowY: 'auto',
      },
      closeButton:{
        textDecoration: 'underline',
        marginTop:-20
      },
      containerLabel:{
        marginTop:5,
        color:'#000',
        marginBottom:10,
      },
      containerLabelMin:{
        marginTop:5,
        color:'#000',
        marginBottom:5,
      },
      containerHeader:{
        marginTop:5,
        marginLeft:20,
        color:'#000',
        marginBottom:10,
      },
      divider:{
        marginTop:10,
        marginBottom:10,
        marginLeft:0,
        marginRight:0,
      },
      selectButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${SelectUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${SelectDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${SelectDown})`,
        },
        marginRight:6,
      },
      deleteButton:{
        border: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${DeleteUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',
        minWidth: 24,
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${DeleteDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${DeleteDown})`,
        },
      },
      polygonButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${DrawNodesUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
        marginRight:6,
      },
      lineButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${DrawNodesUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
        marginRight:6,
      },
      textButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${LabelUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${LabelDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${LabelDown})`,
        },
        marginRight:6,
      },
      fillButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${FillShapeUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${FillShapeDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${FillShapeDown})`,
        },
      },
      measurePolygonButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${MeasureAreaUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${MeasureAreaDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${MeasureAreaDown})`,
        },
        marginRight:6,
      },
      measureLengthButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${MeasureLengthUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 32,
        height: 32,
        '&:hover': {
          backgroundImage: `url(${MeasureLengthDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${MeasureLengthDown})`,
        },
      },
      fontField: {
        width: 120,
        marginTop:10,
      },
      fontSizeField: {
        width: 60,
        marginTop:10,
        paddingLeft:5,
      },
      addTextButton:{
        marginTop:10,
        width:160,
        height: 20,
        color: '#FFF',
        backgroundColor: '#0C4C35',
        '&:hover': {
          backgroundColor: '#63D764'
        },
      },
      textField: {
        minWidth: 140,
        marginTop:10,
      },
      textItemFont:{
        fontSize:11
      },
      properties:{
        padding:10,
      },
      propertiesItem:{
        padding:5,
        border: '1px solid #666',
      },
      propertiesLabel:{
        color:'#000',
      },
      divText:{
        display: textToolDisplay, //'none'
        '& .MuiOutlinedInput-inputMultiline':{
          fontSize: 12,
        }
      },
      divStyle:{
        display: colourPickerDisplay, //'none'
      },
      divMeasurement:{
        display: measurementDisplay, //'none'
      }
  }));

  const classes = useStyles();
  const [selectedTool, setSelectedTool] = useState('none');
  const [captureDisabled, setCaptureDisabled] = useState(true);

  const [outlineStyle, setOutlineStyle] = useState('#f44336'); //Red
  const [outlineThickness, setOutlineThickness] = useState(3); //Medium
  const [areaMeasurement, setAreaMeasurement] = useState(' - ');
  const [lengthMeasurement, setLengthMeasurement] = useState(' - ');
  const [measurementUnits, setMeasurementUnits] = useState('m');

  const [annotationText, setAnnotationText] = useState('');
  const [annotationFont, setAnnotationFont] = useState('Arial');
  const [annotationSize, setAnnotationSize] = useState(12);
  const [annotationDisabled, setAnnotationDisabled] = useState(false);

  
  

  const handlePaperClose = (event) => {

    setSelectedTool('none');
    sDispatch({
      type: "setUserAction",
      payload: { action:"endtools"}
    });
  };

  const handleToolChange = (event) => {
    setSelectedTool(event.target.value);
  };

  //Resets tools if address search is performed.
  useEffect(() => {
    switch(sState.caction){
      case 'addressSearch':
      case 'logout':
        setSelectedTool('none');
      break;
      default:
      break;

    }
  },[sState.caction]);

  useEffect(() => {

    let currentAnnotation = sState.textAnnotation;
    currentAnnotation.text = annotationText;
    //10px sans-serif
    const fontStr = annotationSize.toString()+"px "+annotationFont;
    currentAnnotation.font = fontStr;
    currentAnnotation.source = 'menu';

    sDispatch({ type: "settextannotation", payload: { annotations: currentAnnotation } });
   },[annotationText, annotationSize, annotationFont]);

  /**
   * Handler for creating the text.
   */
  const handleAddText = (event) => {
    sDispatch({ type: "setUserAction", payload: { action: 'createAnnotationText' } });
  };
  

  /**
   * Enables / disable the ploygon capture tool.
   * Baselayer must be OS Mastermap.
   */
 useEffect(() => {
  if (sState.blayer === 'osmm' || sState.blayer === 'osmmbw'){
    setCaptureDisabled(false);
  } else {
    setCaptureDisabled(true);
  }

 },[sState.blayer]);

 useEffect(() => {

  let actionSelected = '';
  setTextToolDisplay('none');
  sDispatch({ type: "annotationselected", payload: { type: 'none' } });
  switch(selectedTool){
    default:
    case "none":
      actionSelected = '';
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;
    case "select":
      actionSelected = 'selectAnnotationObject';
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;
    case "delete":
      actionSelected = 'deleteAnnotation';
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;
    case "polygon":
      actionSelected = 'createAnnotationPolygon';
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;
    case "text":
      //console.log("Add Text selected");
      setAnnotationDisabled(false);
      setTextToolDisplay('block');
      setColourPickerDisplay('none');
      setMeasurementDisplay('none')
    break;
    case "fill":
      actionSelected = 'createAnnotationFill';
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;
    case "measurearea":
      actionSelected = 'createMeasureArea';
      setMeasurementDisplay('block')
    break;
    case "measureline":
      actionSelected = 'createMeasureLine';
      setMeasurementDisplay('block')
    break;
  }
  if (actionSelected !== '') sDispatch({ type: "setUserAction", payload: { action: actionSelected } });
  
},[selectedTool]);

useEffect(() => {
  if (selectedTool === 'select'){

    let lineColour = sState.annotationStyle.outline.colour;
    let lineWidth = sState.annotationStyle.outline.width;
    const linehex = rgbStringToHex(lineColour);

    setOutlineStyle(linehex);
    setOutlineThickness(parseInt(lineWidth));
  }
},[sState.annotationStyle.outline.colour, sState.annotationStyle.outline.width]);

useEffect(() => {
  if (selectedTool === 'select' || selectedTool === 'measurearea'){

    let selectedArea = sState.annotationStyle.area;
    let output = 0;
    if (selectedArea > 10000) {
      output = Math.round((selectedArea / 1000000) * 1000) / 1000+'km'
    } else {
      output = Math.round(selectedArea * 100) / 100+'m'
    }
    setAreaMeasurement(output);
    setLengthMeasurement(' - ');
  }
},[sState.annotationStyle.area]);


/**
 * Listerns for selection of annotation.
 * Used to adjust what tools are displayed on toolbar/
 */

useEffect(() => {

  switch (sState.annotationSelected){
    case "text":
      setAnnotationDisabled(TrainOutlined);
      setTextToolDisplay('block');
      setColourPickerDisplay('none');
      setMeasurementDisplay('none')
    break;
    default:
      setAnnotationDisabled(false);
      setTextToolDisplay('none');
      setColourPickerDisplay('block');
      setMeasurementDisplay('block')
    break;    
  }

},[sState.annotationSelected]);
/**
 * Listerns for selection of text box to modify interface.
 */
useEffect(() => {
  if (sState.textAnnotation.source === 'mapping'){
    setAnnotationDisabled(true);
    setAnnotationText(sState.textAnnotation.text);
    const font = sState.textAnnotation.font.split('px ');
    setAnnotationSize(font[0]);
    setAnnotationFont(font[1]);
    const currentAnnotation = sState.textAnnotation;
    currentAnnotation.source = 'none';
    sDispatch({ type: "settextannotation", payload: { annotations: currentAnnotation } });
  }

},[sState.textAnnotation.source, sState.textAnnotation.text, sState.textAnnotation.font]);

/**
 * Modifies the area measurement
 */
useEffect(() => {

  let areaUnit ='';
  let lengthUnit ='';
  switch (measurementUnits){
    default:
    case "ha":
      areaUnit ='ha';
      lengthUnit ='m';
    break;
    case "acre":
      areaUnit ='acre';
      lengthUnit ='mile';
    break;
    case "feet":
      areaUnit ='feet';
      lengthUnit ='feet';
    break;
    case "m":
      areaUnit ='m';
      lengthUnit ='m';
    break;
    case "km":
      areaUnit ='km';
      lengthUnit ='km';
    break;
  }

  sDispatch({ type: "setmeasurementunits", payload: { units: {area:areaUnit, length:lengthUnit} } })

},[measurementUnits]);

  /**
   * Stores changes to outlinestyle
   */
  useEffect(() => {

    if ((typeof outlineStyle !== 'undefined' && typeof outlineThickness !== 'undefined') && (outlineStyle !== sState.annotationStyle.outline.colour || outlineThickness !== sState.annotationStyle.outline.width)){
      //console.log("outlineStyle="+outlineStyle);
      const s = sState.annotationStyle;
      const c = hexToRgb(outlineStyle);
  
      s.outline.colour = "rgb("+c.r+","+c.g+","+c.b+")";
      s.outline.width = outlineThickness;
  
      //console.log("colourset: "+s.outline.colour+" "+s.outline.width);
  
      sDispatch({type: "setstyle", payload: { style: s }});
    }
  },[outlineStyle,outlineThickness]);


  const rgbStringToHex = (rgb) => {
    rgb = rgb.replace('rgb(', '');
    rgb = rgb.replace(')', '');
    const rgb_parts = rgb.split(',');
    //console.log("rgb_parts: "+rgb_parts[0]+","+rgb_parts[1]+","+rgb_parts[2]);
    return rgbToHex(parseInt(rgb_parts[0]),parseInt(rgb_parts[1]),parseInt(rgb_parts[2]));
  };

  const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    //return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  };

  const componentToHex = (c) => {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  return (
    <div className={classes.paper} >

          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
            <Box display="flex" justifyContent="center" flexGrow={1}><Box className={classes.containerHeader} fontWeight="fontWeightBold" fontSize={14}>Markup Tools</Box></Box>
            <Button className={classes.closeButton} onClick={handlePaperClose}><Box fontSize={8}>Close</Box></Button>
          </Box>
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
            <Box className={classes.containerLabel} fontSize={12}>Select & Delete</Box>
          </Box>
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
            <HtmlTooltip title={<React.Fragment>{"Select to edit markup"}</React.Fragment>}>
                <span>
                <ToggleButton className={classes.selectButton} value="select" selected={selectedTool === 'select'} onChange={handleToolChange} ><div></div></ToggleButton>
                </span>
            </HtmlTooltip>
            <HtmlTooltip title={<React.Fragment>{"Delete selected"}</React.Fragment>}>
            <span><Button className={classes.deleteButton} value="delete" selected={selectedTool === 'delete'} onClick={handleToolChange}></Button></span>
            </HtmlTooltip>
          </Box>
          <Divider className={classes.divider} />
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
            <Box className={classes.containerLabel} fontSize={12}>Create</Box>
          </Box>
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
            <HtmlTooltip title={<React.Fragment>{"Add polygon to map"}</React.Fragment>}>
              <span>
                <ToggleButton className={classes.polygonButton} value="polygon" selected={selectedTool === 'polygon'} onChange={handleToolChange} ><div></div></ToggleButton>
              </span>
            </HtmlTooltip>
            <HtmlTooltip title={<React.Fragment>{"Add text to map"}</React.Fragment>}>
            <span>
                <ToggleButton className={classes.textButton} value="text" selected={selectedTool === 'text'} onChange={handleToolChange} ><div></div></ToggleButton>
                </span>
            </HtmlTooltip>
            <HtmlTooltip title={<React.Fragment>{"Capture area from basemap"}</React.Fragment>}>
            <span>
                <ToggleButton className={classes.fillButton} value="fill" disabled={captureDisabled} selected={selectedTool === 'fill'} onChange={handleToolChange} ><div></div></ToggleButton>
                </span>
            </HtmlTooltip>
          </Box>
          <div className={classes.divText}>
            <Divider className={classes.divider} />
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <TextField
                  id="toolsTextFields"
                  className={classes.toolsTextArea}
                  label="Text to add"
                  multiline
                  rows={4}
                  InputProps={{classes: {input: classes.textItemFont}}} 
                  //defaultValue={annotationText}
                  value={annotationText}
                  variant="outlined"
                  onChange={e => setAnnotationText(e.target.value)}
              />
            </Box>
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <TextField id="textFont" label="Font" value={annotationFont} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.fontField} onChange={e => setAnnotationFont(e.target.value)} select >
                <MenuItem value={"Arial"}>Arial</MenuItem>
                <MenuItem value={"'Courier New'"}>Courier New</MenuItem>
                <MenuItem value={"'Open Sans'"}>Open Sans</MenuItem>
                <MenuItem value={"Verdana"}>Verdana</MenuItem>
              </TextField>
              <TextField id="textSize" label="Size" value={annotationSize} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.fontSizeField} onChange={e => setAnnotationSize(e.target.value)} select >
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={11}>11</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={16}>16</MenuItem>
                <MenuItem value={18}>18</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={24}>24</MenuItem>
                <MenuItem value={28}>28</MenuItem>
                <MenuItem value={32}>32</MenuItem>
              </TextField>
            </Box>
            {!annotationDisabled ? ( 
              <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
                <Button className={classes.addTextButton} onClick={handleAddText}>
                  <Box fontWeight="fontWeightBold" fontSize={12}>Draw text box</Box>
                </Button>
              </Box>) : ('')}
          </div>
          <div className={classes.divStyle}>
            <Divider className={classes.divider} />
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <Box className={classes.containerLabelMin} fontSize={12}>Styles</Box>
            </Box>
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <ToolStylePaper activetool={selectedTool} />
            </Box>
          </div>
          <div className={classes.divMeasurement}>
            <Divider className={classes.divider} />
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <Box className={classes.containerLabel} fontSize={12}>Measurements</Box>
            </Box>
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <HtmlTooltip title={<React.Fragment>{"Measure area by drawing polygon"}</React.Fragment>}>
                <span>
                  <ToggleButton className={classes.measurePolygonButton} value="measurearea" selected={selectedTool === 'measurearea'} onChange={handleToolChange} ><div></div></ToggleButton>
                </span>
              </HtmlTooltip>
              <HtmlTooltip title={<React.Fragment>{"Measure area by drawing a line"}</React.Fragment>}>
                <span>
                  <ToggleButton className={classes.measureLengthButton} value="measureline" selected={selectedTool === 'measureline'} onChange={handleToolChange} ><div></div></ToggleButton>
                </span>
              </HtmlTooltip>
            </Box>
            <Divider className={classes.divider} />
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <TextField id="Units" label="Units" value={measurementUnits} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setMeasurementUnits(e.target.value)} select >
                <MenuItem value={'ha'}>Hectares / m</MenuItem>
                <MenuItem value={'acre'}>Acre / mile</MenuItem>
                <MenuItem value={'feet'}>Sq feet / feet</MenuItem>
                <MenuItem value={'m'}>m² / m</MenuItem>
                <MenuItem value={'km'}>km² / Km</MenuItem>
              </TextField>
            </Box>
            <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
              <Grid container className={classes.properties}>
                  <Grid item xs={12} className={classes.propertiesItem}><Box className={classes.propertiesLabel} display="flex" fontWeight="fontWeightBold" justifyContent="center" fontSize={12}>Properties</Box></Grid>
                  <Grid item xs={5} className={classes.propertiesItem}><Box className={classes.propertiesLabel} fontSize={12}>Area:</Box></Grid>
                  <Grid item xs={7} className={classes.propertiesItem}><Box id="txtAreaMeasurement" className={classes.propertiesLabel} fontSize={12}></Box></Grid>
                  <Grid item xs={5} className={classes.propertiesItem}><Box className={classes.propertiesLabel} fontSize={12}>Length:</Box></Grid>
                  <Grid item xs={7} className={classes.propertiesItem}><Box id="txtLengthMeasurement" className={classes.propertiesLabel} fontSize={12}></Box></Grid>
              </Grid>
            </Box>
          </div>
    </div>
  );
}